import cryptoUtils from "../utils/utils";

/**
 * 
 * Validate HBAR Address 
 * 
 * @param {String} address 
 * @returns 
 */
function isValidHBarAddress (address) {
    const split = address.split('.')
    if (split[0] !== '0' || split[1] !== '0') {
        return false
    }
    if (split[2].length <= 7 && /^\d+$/g.test(split[2])) {
        return true
    }

    return false;
}

/**
 * 
 * Validate EVM Address
 * https://docs.hedera.com/hedera/core-concepts/accounts/account-properties#public-key-account-alias
 * This Validation is same with eth_validator.js
 * 
 * @param {String} address 
 * @returns 
 */
function isValidEVMAddress(address) {
    if (!/^0x[0-9a-fA-F]{40}$/.test(address)) {
        // Check if it has the basic requirements of an address
        return false;
    }
    if (/^0x[0-9a-f]{40}$/.test(address) || /^0x?[0-9A-F]{40}$/.test(address)) {
    // If it's all small caps or all all caps, return true
        return true;
    }

    return verifyChecksum(address);
}

/**
 * Verify EVM Checksum
 * @param {String} address 
 * @returns 
 */
function verifyChecksum(address) {
    // Check each case
    address = address.replace("0x", "");
    const addressHash = cryptoUtils.keccak256(address.toLowerCase());

    for (let i = 0; i < 40; i++) {
      // The nth letter should be uppercase if the nth digit of casemap is 1
      if (
        (parseInt(addressHash[i], 16) > 7 &&
          address[i].toUpperCase() !== address[i]) ||
        (parseInt(addressHash[i], 16) <= 7 &&
          address[i].toLowerCase() !== address[i])
      ) {
        return false;
      }
    }

    return true;
}

export default {
    isValidAddress: function (address, currency, networkType) {
        return isValidHBarAddress(address) || isValidEVMAddress(address);
    }
}
